import React from 'react'

const Eventsbannerspage = () => {
    return (
        <div>

        </div>
    )
}

export default Eventsbannerspage
